// write a card similar to the DuplicateSurveyCard but for deleting surveys. It should have a dropdown to select a survey and a delete button that calls the delete API endpoint. It should also have a confirmation modal before calling the API.

import React, { useState } from 'react';
import { BrandButton as Button, SearchableSelect } from "@/components";

/**
 * Card component for deleting surveys
 * Deletes an existing survey by selecting it from a dropdown
 */

export default function DeleteSurveyCard({
  publishedSurveys,
  selectedSurveyId,
  onSurveyChange,
  onDeleteClick,
  instanceCount,
  loading
}) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const handleDeleteClick = () => {
    if (!selectedSurveyId) return;
    // fetch how many instances exist of this survey and warn the user with this info in the confirmation modal (if there are instances) before confirming deletion

    // Show confirmation modal before deleting
    setShowConfirmModal(true);
  };

  const confirmDelete = () => {
    onDeleteClick(selectedSurveyId);
    setShowConfirmModal(false);
  };

  const cancelDelete = () => {
    setShowConfirmModal(false);
  };

  return (
    <div className="col-md-6 mb-4">
      <div className="card h-100" style={{ border: "3px solid #dc3d17", borderRadius: "10px" }}>
        <div className="card-body">
          <h4 className="card-title" style={{ color: "#F16D09" }}>Delete Survey</h4>
          <p className="card-text">
            Permanently delete an existing survey. This action cannot be undone, so please proceed with caution.
          </p>
          {/* check for how many instances the survey has and warn the user with this info */}
          <div className="alert alert-sm alert-warning" style={{ fontSize: '0.9rem' }}>
            Warning: Deleting a survey will permanently remove all associated data. Make sure to export any necessary data before deletion.
          </div>
          
          <div className="mb-3">
            <label className="form-label ">Select Survey to Delete:</label>
            <SearchableSelect
              options={[...publishedSurveys].sort((a, b) => a.title.localeCompare(b.title))}
              value={selectedSurveyId || ''}
              onChange={(surveyId) => onSurveyChange(surveyId || "")}
              placeholder="Search or select..."
              getLabel={(survey) => survey.title}
              getValue={(survey) => survey.id}
              disabled={loading}
            />
          </div>
          
          <Button 
            onClick={handleDeleteClick}
            disabled={!selectedSurveyId || loading}
            variant="danger"
            style={{ width: "100%" }}
          >
            Delete Survey
          </Button>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(247, 4, 4, 0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button type="button" className="btn-close" onClick={cancelDelete}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this survey? This action cannot be undone and should be used with EXTREME CAUTION! We envisage this use case to be for test surveys or errors only.</p>
                {instanceCount !== null && instanceCount > 0 && (
                  <div className="alert alert-danger mt-2 mb-0">
                    <strong>Warning:</strong> This survey has <strong>{instanceCount}</strong> active instance{instanceCount !== 1 ? 's' : ''} with associated data. All data will be permanently lost.
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <Button variant="secondary" onClick={cancelDelete}>Cancel</Button>
                <Button variant="danger" onClick={confirmDelete}>Delete</Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}   